import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';

export const guestGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean | UrlTree => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const token = authService.getAccessToken();
  const tokenExpired = authService.isTokenExpired();

  // ✅ If logged in and token is valid
  if (token && !tokenExpired) {
    // 1️⃣ Read returnUrl (if exists)
    const returnUrl = route.queryParamMap.get('returnUrl');

    // 2️⃣ Sanitize (only allow internal URLs)
    const safeUrl = returnUrl && returnUrl.startsWith('/')
      ? returnUrl
      : '/dashboard';

    // 3️⃣ Redirect to safe destination
    return router.createUrlTree([safeUrl]);
  }

  // ✅ If not logged in, allow access to login/register
  return true;
};
